import { STAFF, STUDENT, PARENT } from "Constants/stringConstants";

export const isUserTypeStaff = ({ userType }) => {
  return userType === STAFF;
};

export const isUserTypeStudent = ({ userType }) => {
  return userType === STUDENT;
};

export const isUserTypeParent = ({ userType }) => {
  return userType === PARENT;
};

export const isUserTypeStudentOrParent = ({ userType }) => {
  return isUserTypeStudent({ userType }) || isUserTypeParent({ userType });
};
